<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_rate") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper justify-content-between">
        <div class="wrapper">
          <v-chip color="amber darken-2" text-color="white">
            {{ $t("PLACEHOLDERS.created_at") }}: {{ data.created_at }}
          </v-chip>
        </div>

        <v-chip :color="getStatusColor(data.status)" text-color="white">
          {{ data.status_translation }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->

      <!-- ==== Start:: Rate Main Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Student Image -->
          <div class="col-12 text-center my-3" v-if="data.user?.image">
            <div class="preview-container text-center my-3">
              <img
                v-if="data.user.image"
                col="12"
                :src="data.user.image"
                :alt="$t('PLACEHOLDERS.personalImage')"
              />
            </div>
          </div>
          <div class="col-12 text-center my-3" v-else>
            <div class="no-image-placeholder">
              <i class="fas fa-user fa-3x"></i>
              <p>{{ $t("PLACEHOLDERS.no_image") }}</p>
            </div>
          </div>
          <!-- End:: Student Image -->

          <!-- Start:: Student Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.student_name')"
            v-model.trim="data.user.name"
            disabled
          />
          <!-- End:: Student Name -->

          <!-- Start:: Course Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.course_name')"
            v-model.trim="data.course"
            disabled
          />
          <!-- End:: Course Name -->

          <!-- Start:: Rate Display -->
          <div class="col-6">
            <div class="input_wrapper">
              <label>{{ $t("PLACEHOLDERS.rate") }}</label>
              <div class="rate-display">
                <div class="stars-wrapper">
                  <i
                    v-for="star in 5"
                    :key="star"
                    :class="[
                      'fas fa-star',
                      star <= data.rate ? 'filled' : 'empty',
                    ]"
                  ></i>
                </div>
                <span class="rate-number">({{ data.rate }}/5)</span>
              </div>
            </div>
          </div>
          <!-- End:: Rate Display -->

          <!-- Start:: Creation Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Creation Date -->

          <!-- Start:: Comment -->
          <base-input
            col="12"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.comment')"
            v-model.trim="data.comment"
            disabled
          />
          <!-- End:: Comment -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ShowRate",

  
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      data: {
        id: null,
        user: {
          name: "",
          image: null,
        

},
        course: "",
        rate: 0,
        comment: "",
        status: "",
        status_translation: "",
        created_at: "",
      },
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // Get status color based on status value
    getStatusColor(status) {
      switch (status) {
        case "new":
          return "blue";
        case "published":
          return "green";
        case "blocked":
          return "red";
        default:
          return "grey";
      }
    },

    async showRate() {
      this.isWaitingRequest = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `rates/${this.$route.params?.id}`,
        });

        // Assign data from API response
        this.data = res.data.data.Rate;
      } catch (error) {
        this.isWaitingRequest = false;
        console.log(error?.response?.data?.message);
        this.$message.error(
          error?.response?.data?.message || "حدث خطأ أثناء تحميل البيانات"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },
  },

  created() {
    this.showRate();
  },
};
</script>

<style scoped>
.single_show_content_wrapper {
  padding: 20px;
}

.badges_wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.badges_wrapper .wrapper {
  display: flex;
  gap: 10px;
}

.preview-container {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 20px;
  background: #f8f9fa;
}

.student-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #3eb6d4;
}

.no-image-placeholder {
  color: #999;
  padding: 30px;
}

.no-image-placeholder i {
  color: #ddd;
  margin-bottom: 10px;
}

.rate-display {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 5px;
  margin-top: 5px;
}

.stars-wrapper {
  display: flex;
  gap: 3px;
}

.stars-wrapper .fa-star.filled {
  color: #ffc107;
}

.stars-wrapper .fa-star.empty {
  color: #e0e0e0;
}

.rate-number {
  font-weight: bold;
  color: #3eb6d4;
}

.status-display {
  padding: 10px 0;
}

.input_wrapper label {
  font-weight: 600;
  margin-bottom: 5px;
  color: #333;
  display: block;
}
</style>
